var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteShowAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84195 1.05261H13.1577C13.7391 1.05261 14.2103 1.52393 14.2103 2.10522V3.15783H5.78923V2.10522C5.78934 1.52393 6.26066 1.05261 6.84195 1.05261ZM4.73673 3.15794V2.10533C4.73673 0.942527 5.67926 0 6.84195 0H13.1577C14.3204 0 15.2629 0.942527 15.2629 2.10522V3.15783H18.4209C18.7114 3.15783 18.9472 3.39343 18.9472 3.68413C18.9472 3.97483 18.7114 4.21043 18.4209 4.21043H1.57879C1.28809 4.21043 1.05249 3.97483 1.05249 3.68413C1.05249 3.39343 1.28809 3.15783 1.57879 3.15783H4.73673V3.15794Z",
    fill: "#CB0B0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84198 17.3684C6.55128 17.3684 6.31567 17.1327 6.31567 16.8421V8.94745C6.31567 8.65686 6.55128 8.42114 6.84198 8.42114C7.13269 8.42114 7.36829 8.65686 7.36829 8.94745V16.8421C7.36829 17.1327 7.13269 17.3684 6.84198 17.3684Z",
    fill: "#CB0B0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99994 17.3684C9.70935 17.3684 9.47363 17.1327 9.47363 16.8421V8.94745C9.47363 8.65686 9.70935 8.42114 9.99994 8.42114C10.2905 8.42114 10.5262 8.65686 10.5262 8.94745V16.8421C10.5262 17.1327 10.2905 17.3684 9.99994 17.3684Z",
    fill: "#CB0B0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1577 17.3684C12.8671 17.3684 12.6313 17.1327 12.6313 16.8421V8.94745C12.6313 8.65686 12.8671 8.42114 13.1577 8.42114C13.4482 8.42114 13.684 8.65686 13.684 8.94745V16.8421C13.684 17.1327 13.4484 17.3684 13.1577 17.3684Z",
    fill: "#CB0B0B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15771 18.9474V6.31585C3.15771 6.02515 3.39332 5.78955 3.68402 5.78955C3.97472 5.78955 4.21032 6.02515 4.21032 6.31585V17.8948C4.21032 18.4762 4.68164 18.9474 5.26293 18.9474H14.7366C15.318 18.9474 15.7892 18.4762 15.7892 17.8948V6.31585C15.7892 6.02515 16.0249 5.78955 16.3155 5.78955C16.6061 5.78955 16.8418 6.02515 16.8418 6.31585V18.9474C16.8418 19.5288 16.3706 20 15.7892 20H4.21032C3.62892 20.0001 3.15771 19.5288 3.15771 18.9474Z",
    fill: "#CB0B0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteShowAccount);
export default __webpack_public_path__ + "static/media/icon-delete-show-account.e70940f9becc269c41c231f6daf57334.svg";
export { ForwardRef as ReactComponent };